export default {"src":"/_next/static/media/mh.2413105f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};